module.exports = __webpack_public_path__ + "static/media/healthcare_doc_slider_phone2.9613f2ef.png";